import React, { useEffect, useState, memo } from 'react'
import Box from '@mui/material/Box'
import Dialog from '@mui/material/Dialog'
import Typography from '@mui/material/Typography'
// import { FormattedMessage } from 'react-intl'
import Container from '@mui/material/Container'
import sx from './styles'

const LoadingDialog = ({
  open, mainTitle, title, subtitles = [], icon, description,
}) => {
  const [activeIndex, setActiveIndex] = useState(0)
  let interval

  useEffect(() => {
    if (subtitles && subtitles.length > 0) {
      interval = setInterval(
        () => setActiveIndex((prev) => (prev + 1) % subtitles.length),
        1000,
      )
    }
    return () => {
      if (subtitles && subtitles.length > 0) {
        clearInterval(interval)
      }
    }
  }, [subtitles])

  return (
    <Dialog
      open={open}
      fullScreen
      PaperProps={{
        sx: sx.paper,
      }}
    >

      <Container maxWidth="md">
        <Box sx={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
        }}
        >
          {mainTitle && (
            <Typography
              variant="h2"
              component="p"
              sx={sx.line0}
            >
              {/* <FormattedMessage id="APPRAISAL_GENIAL" />
              <br /> */}
              {mainTitle}
            </Typography>
          )}

          <Typography
            variant="h3"
            component="p"
            sx={sx.line1}
          >
            {title}
          </Typography>

          <Box
            m={2}
            sx={{
              textAlign: 'center',
            }}
          >
            {icon}
          </Box>

          {subtitles && subtitles.length > 0 && (
            <Typography
              variant="h3"
              component="p"
              sx={sx.line2}
            >
              {subtitles[activeIndex]}
            </Typography>
          )}

          {description && (
            <Typography
              variant="h3"
              component="p"
              sx={sx.line2}
            >
              {/* <Typography
                variant="h3"
                component="span"
                sx={sx.line3}
              >
                <FormattedMessage id="APPRAISAL_TIPS_CLIKAUTO" />
              </Typography> */}
              {description}
            </Typography>
          )}
        </Box>
      </Container>

    </Dialog>
  )
}

export default memo(LoadingDialog)
